import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './theme.css';
import './app.css';

const root = document.getElementById('root');
if (!root) throw new Error('No se encontró el nodo raíz');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
